__turbopack_context__.v({
  "root": "Table-module__zud4CW__root",
});
